import { nodeViewContainer } from './renderers/plugins/nodeViewContainer.js';
import { getAnchor } from '../components/Anchor.js';
import 'react';
import 'lodash';
import '../../getClassNames-a0522f4d.js';
import 'ricos-context';
import 'classnames';
import './utils/Anchorable.js';
import './renderers/plugins/ContainerElement.js';
import 'wix-rich-content-common';
import './utils/paywallSeo.js';
import 'ricos-schema';
import '../components/ErrorBoundary.js';

function visit(node, renderers, nodeViewDecorators, RicosNodesRenderer, nodeIndex, isRoot, fallback) {
  var _a;
  const renderer = renderers[node.type];
  if (!renderer) {
    console.error(`Rericos Error: no renderer passed for node type - ${node.type}`);
    if (!fallback) {
      console.warn("Rericos Suggestion: pass a fallback renderer for nodes without a renderer");
    }
    return (_a = fallback == null ? void 0 : fallback(node)) != null ? _a : null;
  }
  return nodeViewDecorators.apply(
    renderer({ node, RicosNodesRenderer, isRoot, nodeIndex, NodeViewContainer: nodeViewContainer }),
    node
  );
}
function traverseNodes(nodes, renderers, nodeViewDecorators, RicosNodesRenderer, isRoot, addAnchorsPrefix, fallback) {
  return nodes.reduce((visited, node, index) => {
    return [
      ...visited,
      visit(node, renderers, nodeViewDecorators, RicosNodesRenderer, index, isRoot, fallback),
      ...addAnchorsPrefix ? [getAnchor(node, index, addAnchorsPrefix)] : []
    ];
  }, []);
}

export { traverseNodes };
//# sourceMappingURL=render.js.map
